import { isApiResponseError } from "tf-api-client";

type Translator = {
  t: (key: string) => string;
  te: (key: string) => boolean;
};

// Message for a failed API call: the translation of its code
// (`errors.<title>`), else the server's own `detail`, else the generic text.
// Screens that give some codes their own wording check those first.
export const apiErrorText = ({ t, te }: Translator, err: unknown): string => {
  if (isApiResponseError(err)) {
    if (te(`errors.${err.code}`)) return t(`errors.${err.code}`);
    if (err.response.detail) return err.response.detail;
  }
  return t("errors.unknown_error");
};
